import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function CGUPage() {
    const [data, setData] = useState({ html: "", version: "", last_updated: "" });
    useEffect(() => {
        api.get("/legal/cgu")
            .then((r) => setData(r.data))
            .catch(() => {});
    }, []);
    // API base for the PDF download (needs the /api prefix)
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    return (
        <div>
            <Header />
            <div className="max-w-4xl mx-auto px-6 py-14">
                <div className="overline mb-2">Cadre légal</div>
                <h1 className="font-display text-4xl md:text-5xl mb-2">
                    Conditions Générales d'Utilisation
                </h1>
                <div className="text-sm text-slate-500 mb-6">
                    Version <b>{data.version}</b> — Mise à jour le {data.last_updated}
                </div>
                <a
                    href={`${backendUrl}/api/legal/cgu.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-gold text-sm inline-block mb-8"
                    data-testid="cgu-download-pdf"
                >
                    📄 Télécharger le PDF
                </a>
                <div
                    className="sd-card p-8 prose prose-slate max-w-none"
                    dangerouslySetInnerHTML={{ __html: data.html }}
                    data-testid="cgu-content"
                />
            </div>
            <Footer />
        </div>
    );
}
